module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/$.path.js
 ** module id = 426
 ** module chunks = 0
 **/